<template>
    <div class="co-novidades">
        <iframe src="https://azcronos.com.br/categoria/besign/" loading="eager" class="iframe" id="iframe"/>
        <basic-loading v-if="loading"/>
    </div>
</template>

<script>
import BasicLoading from '@/commons/components/BasicLoading'

export default {
    name: 'Novidades',
    components: {BasicLoading},
    data() {
        return {
            loading: true
        }
    },
    mounted() {
        this.$store.state.loki.page.title = 'Novidades'
        const iframeEle = document.getElementById('iframe');

        iframeEle.addEventListener('load', this.pararLoading);
    },
    methods: {
        pararLoading() {
            this.loading = false
        }
    }
}
</script>

<style lang="stylus">
.co-novidades
    background-color var(--background-100) !important
    padding 0
    width 100%
    height calc(100% - 36px)

    .iframe
        border none
        width 100%
        height 100%
        padding 0
        margin 0
</style>